import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from 'framer-motion';
import "./Testimony.css";

// Dynamically require all images in the reviews folder
function importAll(r) {
  return r.keys().map(r);
}
const reviewImages = importAll(require.context("../../images/reviews", false, /\.(jpg|jpeg|png|gif)$/));

const Testimony = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = reviewImages.length;
  const touchStartX = useRef(null);

  // Touch/swipe handlers for mobile
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const deltaX = touchEndX - touchStartX.current;
    if (deltaX > 50) {
      // Swipe right (previous)
      setCurrentIndex((prev) => (prev - 1 + total) % total);
    } else if (deltaX < -50) {
      // Swipe left (next)
      setCurrentIndex((prev) => (prev + 1) % total);
    }
    touchStartX.current = null;
  };

  const goToPrev = () => setCurrentIndex((prev) => (prev - 1 + total) % total);
  const goToNext = () => setCurrentIndex((prev) => (prev + 1) % total);

  return (
    <div className="carousel-container">
        <motion.div 
                    className="section-header"
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2>What Our Clients Say</h2>
                    <p>Real stories from real people on their journey to wellness</p>
                </motion.div>
      <div className="carousel-image-wrapper"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={reviewImages[currentIndex]}
          alt={`Review ${currentIndex + 1}`}
          className="carousel-image"
        />
      </div>
      <div className="carousel-arrows-row">
        <button className="carousel-nav-btn prev" onClick={goToPrev} aria-label="Previous testimonial">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#F6F9FC"/><path d="M14.5 17L10 12.5L14.5 8" stroke="#205080" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <button className="carousel-nav-btn next" onClick={goToNext} aria-label="Next testimonial">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#F6F9FC"/><path d="M9.5 17L14 12.5L9.5 8" stroke="#205080" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
      </div>
      <div className="carousel-counter">
        {currentIndex + 1} / {total}
      </div>
    </div>
  );
};

export default Testimony;